import { AddressType, type GetOrganizationAddressesQuery } from '@codezo/graphql';

/** One of the organization's own addresses, as `getOrganizationAddresses` returns it. */
export type OrganizationAddress = GetOrganizationAddressesQuery['getOrganizationAddresses'][number];

export const ADDRESS_TYPE_LABEL: Record<AddressType, string> = {
	[AddressType.Billing]: 'Billing',
	[AddressType.Branch]: 'Branch',
	[AddressType.Headquarters]: 'Headquarters',
	[AddressType.Other]: 'Other',
	[AddressType.Shipping]: 'Shipping',
};

/**
 * Anything address-shaped. Every part is optional because the order's and the
 * quote's copies are — only the saved ones have the fields guaranteed.
 */
export interface AddressLike {
	addressLine1?: string | null;
	addressLine2?: string | null;
	city?: string | null;
	postalCode?: string | null;
	stateCode?: string | null;
	countryCode?: string | null;
}

/**
 * The address as it would be written on a label, one line per element, with the
 * blanks dropped — `addressLine2` and `stateCode` are optional on every country.
 */
export function formatAddressLines(address: AddressLike): string[] {
	return [
		address.addressLine1,
		address.addressLine2,
		[address.postalCode, address.city].filter(Boolean).join(' '),
		[address.stateCode, address.countryCode].filter(Boolean).join(', '),
	].filter((line): line is string => !!line && line.trim().length > 0);
}
